import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { CandidatoService } from '../candidato.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { Perfis } from '../../../models/perfis';
import { AuthService } from '../../admin/auth.service';

@Component({
  selector: 'sispac-visualizar-historico',
  templateUrl: './visualizar-historico.component.html',
  styleUrls: ['./visualizar-historico.component.css']
})
export class VisualizarHistoricoComponent extends WebPage implements OnInit {
  candidato;
  idCandidato;
  listaHistorico;
  perfis;
  usuario;
  constructor(private confirmationService: ConfirmationService,
    private route: ActivatedRoute, private router: Router,
    private arquivoService: ArquivoService,
    private authService: AuthService,
    private candidatoService: CandidatoService,
                      messageService: MessageService) {
    super(messageService);

    this.usuario = this.authService.informacoesUsuario();
    this.perfis = Perfis;

    this.route.paramMap.subscribe(params =>
      this.idCandidato = params.get('idCandidato')
    );
   }

  ngOnInit() {
    this.isLoading = true;

    this.candidatoService.getFull(this.idCandidato)
      .finally(() => this.isLoading = false)
      .subscribe(
        candidato => {
          this.candidato = candidato;
        },
        error => this.gerenciaErro(error)
      );
      this.getHistorico();
  }


  getHistorico() {
    this.candidatoService.getHistoricoCandidato(this.idCandidato)
      .finally(() => this.isLoading = false)
      .subscribe(
        listaHistorico => {
          this.listaHistorico = listaHistorico;
          console.log(this.listaHistorico);
        },
        error => this.gerenciaErro(error)
      );
  }

  visualizar(idArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, 'Arquivo');
  }

  editar(idArquivo) {
    this.router.navigate(['/alterar-arquivo', idArquivo, this.idCandidato]);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/candidato/visualizar-historico/visualizar-historico.component.ts